import 'video-react/dist/video-react.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Player } from 'video-react';
import { addcontext } from '../../ContextShare/ContextShare';
import { UpdateViewCount } from '../../Services/allApi';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSearchParams } from 'react-router-dom';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  playerWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  poster: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  }
};

const responsiveWrapperStyle = {
  width: '100%',
  height: '100%',
};

// const responsiveWrapperClass = {
//   width: '100%',
//   height: '100%',
// };

function VideoBoxSection() {
  const playerRef = useRef(null);
  const baseUrl = process.env.REACT_APP_BASEURL;
  const altimg = process.env.REACT_APP_ALT_IMG;
  const { videoUrl, setVideoUrl } = useContext(addcontext);
  const { videoThumb, setVideoThumb } = useContext(addcontext);
  const { videoData, setVideoData } = useContext(addcontext);
  const { whichPageIsSendingData, setwhichPageIsSendingData } = useContext(addcontext);
  const [isUserViewedVideo, setIsUserViewedVideo] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    setIsUserViewedVideo(false);
    setKey(prevKey => prevKey + 1);
  }, [videoUrl]);

  // autoplay when opened via "Watch in new tab" (?autoplay=1)
  // captured once on mount, VideoPlay re-navigates without the query string
  const [searchParams] = useSearchParams();
  const autoplayPending = useRef(searchParams.get('autoplay') === '1');
  useEffect(() => {
    if (!autoplayPending.current || !videoUrl) return;
    const el = playerRef.current?.video?.video;
    if (!el) return;
    const start = () => {
      autoplayPending.current = false;
      el.play()?.catch(() => {
        // browser blocked autoplay with sound, retry muted
        el.muted = true;
        el.play()?.catch(() => {});
      });
    };
    // wait until the source has loaded: video-react resets hasStarted on loadstart,
    // so playing earlier brings the poster back over the video (audio only)
    if (el.readyState >= 2) {
      start();
      return;
    }
    el.addEventListener('canplay', start, { once: true });
    return () => el.removeEventListener('canplay', start);
  }, [key]); // key bumps after videoUrl changes and the Player remounts

  // update view count on playing the video
  const handlePlay = async () => {
    try {
      if (isUserViewedVideo === false) {
        setIsUserViewedVideo(true);
        const result = await UpdateViewCount(videoData.mapping_id);
        console.log(result);
      }
    } catch (error) {
      toast.error('There was an error');
    }
  };

  return (
    <div style={styles.container}>
      <div className="lg:w-9/12 w-full" >
        {videoUrl ? (
          <Player
            key={key}
            ref={playerRef}
            aspectRatio="16:9"
            poster={videoThumb ? `${baseUrl}${videoThumb}` : altimg}
            width="100%"
            height="100%"
            onPlay={handlePlay}
          >
            <source src={videoUrl && videoUrl} />
          </Player>
        ) : (
          <Skeleton height={250} />
        )}
      </div>
    </div>
  );
}

export default VideoBoxSection;


// import 'video-react/dist/video-react.css';
// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { Player } from 'video-react';
// import { addcontext } from '../../ContextShare/ContextShare';
// import { GetSpecificVideo, UpdateViewCount, UpdateViewCountBS, UpdateViewCountGA, UpdateViewCountRl } from '../../Services/allApi';
// import { toast } from 'react-toastify';
// import { useParams } from 'react-router-dom';
// import Skeleton from 'react-loading-skeleton'
// import 'react-loading-skeleton/dist/skeleton.css'
// function VideoBoxSection() {
//   const playerRef = useRef(null);
//   const baseUrl = process.env.REACT_APP_BASEURL;
//   const altimg=process.env.REACT_APP_ALT_IMG
//   // const params = useParams();
//   // const videoIdFromUrl = params.vId;
//   // const [vIdToUrl, setVIdToUrl] = useState('');

//   const { videoUrl, setVideoUrl } = useContext(addcontext);
//   const { videoThumb, setVideoThumb } = useContext(addcontext);
//   const {videoData,setVideoData}=useContext(addcontext)
//   const {whichPageIsSendingData,setwhichPageIsSendingData}=useContext(addcontext)
//   const[isUserViewedVideo,setIsUserViewedVideo]=useState(false)
//   const [key, setKey] = useState(0); // Initialize key state

// //   const getTagsForVideo = async () => {
// //     if (vIdToUrl) {
// //       const res=await GetSpecificVideo(vIdToUrl)
// //       console.log('ressss',res);
// //       setVideoData(res?.data?.data)
// //       setVideoUrl(res?.data?.data?.video_url)
// //       setVideoThumb(res?.data?.data?.video_thumbnail)
// //     }
// // };

// // useEffect(() => {
// //     const newId = videoIdFromUrl?.replace(/:/g, '');
// //     setVIdToUrl(newId);
// // }, [videoIdFromUrl]);

// // useEffect(() => {
// //     getTagsForVideo();
// // }, [vIdToUrl]);


//   useEffect(() => {
//     setIsUserViewedVideo(false); // Reset the viewed video flag when URL changes
//     setKey(prevKey => prevKey + 1); // Update key to re-mount Player component
//   }, [videoUrl]); // Listen for changes in videoUrl


//   const handlePlay = async() => {
//     try{
//       if(isUserViewedVideo==false){
//         setIsUserViewedVideo(true)
        
//           const result=await UpdateViewCount(videoData.mapping_id)
//           console.log(result);
        
//         }
//     }catch(error){
//       toast.error('There was an error')
//     }
//    }  
 

//   return (
//     <div className='flex justify-center w-full h-full'>
//       <div className='lg:w-9/12 w-full' style={{ height: '100%' }}>
//        {videoUrl? <Player
//          key={key} // Pass key prop to force re-mounting when videoUrl changes
//           ref={playerRef}
//           aspectRatio='16:9'
//           poster={videoThumb?${baseUrl}${videoThumb}:altimg}
//           width={'100%'}
//           height={'100%'}
//           onPlay={handlePlay} // Handle play event
//         >
//           <source src={videoUrl && videoUrl} />
//         </Player>
//         :
//         <Skeleton  height={250}/>

//         }
//       </div>
//     </div>
//   );
// }

// export default VideoBoxSection;